import { makeStyles, fade } from '@material-ui/core';

export const useMenuStyles = makeStyles((theme) => ({
    menuItem: {
        '&:hover': { backgroundColor: fade(theme.palette.primary.main, 0.5) },
        '&:focus': { backgroundColor: theme.palette.primary.main },
    },
}));
